import { LinearProgress, List, ListItem, Stack, Typography } from '@mui/material'
import { selectLastRecurrenceSuccess } from '@/features/domain/history'
import { selectUserConfiguration } from '@/features/domain/user'
import { useCreateFormatDate } from '@/hooks'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useTexts } from '../../useTexts'

type Props = {
  percentage: number
  totalOrders: number
  currentOrders: number
}

export function OperationalWarning(props: Props) {
  const { percentage, totalOrders, currentOrders } = props

  const lastRecurrenceSuccess = useSelector(selectLastRecurrenceSuccess)
  const { today } = useSelector(selectUserConfiguration)
  const formatDate = useCreateFormatDate()
  const texts = useTexts()

  const isDisplayPointTwoWithDate =
    lastRecurrenceSuccess && lastRecurrenceSuccess > today && percentage === 100

  return (
    <Stack width={444} direction="column" spacing={3}>
      <Stack direction="column" spacing={1}>
        <Stack direction="row" alignItems="center" spacing={2} width="100%">
          <LinearProgress
            variant="determinate"
            value={percentage}
            color="error"
            sx={{
              height: 8,
              flex: 1,
              borderRadius: '2px',
            }}
          />
          <Typography variant="body2">{`${percentage}%`}</Typography>
        </Stack>
        <Typography variant="caption">{`${currentOrders} of ${totalOrders} ${texts.ordersText}`}</Typography>
      </Stack>

      <Stack direction="column" spacing={2}>
        <Typography variant="body1">{texts.operationalDescription}</Typography>

        <List
          component="ul"
          sx={{
            pl: 4,
            listStyleType: 'disc',
            '& > li': {
              display: 'list-item',
              mb: 2,
              p: 0,
            },
          }}
        >
          <ListItem>
            <Typography variant="body1">{texts.explanationPoint1}</Typography>
          </ListItem>
          <ListItem>
            <Typography variant="body1">
              {isDisplayPointTwoWithDate ? (
                <FormattedMessage
                  id={'outOfStorageSpaceModal.details.operation.point2.alternative'}
                  values={{
                    b: chunks => (
                      <Typography
                        component="span"
                        variant="body2"
                        fontWeight="bold"
                        display="inline"
                      >
                        {chunks}
                      </Typography>
                    ),
                    date: lastRecurrenceSuccess ? formatDate(lastRecurrenceSuccess, true) : '',
                  }}
                />
              ) : (
                texts.explanationPoint2
              )}
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </Stack>
  )
}
